import { useState } from 'react';
import { Dialog, DialogContent } from './ui/dialog';
import { Button } from './ui/button';
import { Eye, Copy, X } from 'lucide-react';
import { toast } from 'sonner';

const isPdf = (url) => url && (url.startsWith('data:application/pdf') || url.endsWith('.pdf'));

const ImagePreview = ({ imageUrl, label = "Image" }) => {
  const [showPreview, setShowPreview] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(imageUrl);
      toast.success(`${label} copied to clipboard!`);
    } catch (error) {
      toast.error('Failed to copy to clipboard');
    }
  };

  if (!imageUrl) {
    return <span className="text-slate-500 text-sm">No image</span>;
  }

  return (
    <div className="flex items-center gap-2">
      <Button
        type="button"
        onClick={() => setShowPreview(true)}
        variant="outline"
        size="sm"
        className="gap-2"
      >
        <Eye className="w-4 h-4" />
        Preview
      </Button>
      <Button
        type="button"
        onClick={handleCopy}
        variant="outline"
        size="sm"
        className="gap-2"
      >
        <Copy className="w-4 h-4" />
        Copy
      </Button>

      <Dialog open={showPreview} onOpenChange={setShowPreview}>
        <DialogContent className="max-w-4xl">
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-semibold">{label} Preview</h3>
              <Button
                onClick={() => setShowPreview(false)}
                variant="ghost"
                size="sm"
              >
                <X className="w-4 h-4" />
              </Button>
            </div>
            <div className="bg-slate-100 rounded-lg p-4">
              {isPdf(imageUrl) ? (
                <iframe
                  src={imageUrl}
                  title={label}
                  className="w-full rounded"
                  style={{ height: '70vh' }}
                />
              ) : (
                <img
                  src={imageUrl}
                  alt={label}
                  className="max-w-full h-auto mx-auto rounded"
                  style={{ maxHeight: '70vh' }}
                />
              )}
            </div>
            <div className="flex gap-2 justify-end">
              <Button onClick={handleCopy} variant="outline" className="gap-2">
                <Copy className="w-4 h-4" />
                Copy Base64
              </Button>
              <Button onClick={() => setShowPreview(false)}>Close</Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ImagePreview;
